import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-toastr',
	templateUrl:'./ToastrPluginPage.html',
	styles: [],
	styleUrls:['./ToastrPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ToastrPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_657 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>toastr</artifactId>
</dependency>
\`\`\``;
	mdContent_658 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:toastr:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_659 = `\`\`\`json
"toastr": "^2.1.4"
\`\`\``;
	mdContent_660 = `\`\`\`java
// Info toast
addFeature(new ToastrFeature<>("Hello World"));

// Success toast
addFeature(new ToastrFeature<>(ToastrType.Success, "Done!", "Saved."));

// Error toast with options
var toast = new ToastrFeature<>(ToastrType.Error, "Error", "Something failed.");
toast.getOptions().setCloseButton(true).setProgressBar(true);
addFeature(toast);
\`\`\``;
	mdContent_661 = `\`\`\`java
var toast = new ToastrFeature<>(ToastrType.Warning, "Alert", "Attention needed");
toast.getOptions()
     .setPositionClass(ToastrPosition.Toast_Bottom_Center)
     .setTimeOut(10000)
     .setShowEasing(JQEasingEffects.easeInOutQuad)
     .setHideEasing(JQEasingEffects.easeOutBounce)
     .setNewestOnTop(false)
     .setPreventDuplicates(true);
\`\`\``;
	mdContent_662 = `\`\`\`java
// Simple info toast
addFeature(new ToastrFeature<>("Hello World"));

// Toast with type, title, and message
addFeature(new ToastrFeature<>(
    ToastrType.Success, "Done!", "Changes saved."));

// Customized toast
var toast = new ToastrFeature<>(
    ToastrType.Warning, "Alert", "Check this");
toast.getOptions()
     .setPositionClass(ToastrPosition.Toast_Top_Center)
     .setCloseButton(true)
     .setProgressBar(true)
     .setTimeOut(3000);
addFeature(toast);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
